import { render, staticRenderFns } from "./ChangePassWord.vue?vue&type=template&id=56c63403&"
import script from "./ChangePassWord.vue?vue&type=script&lang=js&"
export * from "./ChangePassWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports